// Override Settings
var bcSfSearchSettings = {
  search: {
    // suggestionMode: 'test',
    // suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {};

// Build number of Search result
// BCSfFilter.prototype.buildSearchResultNumber = function(data) {
//   var content = '';
//   var searchTerm = this.escape(this.getSearchTerm());
//   if (searchTerm != null) {
//       var content = bcSfFilterConfig.label.search_result_number_other;
//       if (data.total_product <= 1) {
//           var content = bcSfFilterConfig.label.search_result_number_one;
//       }
//       content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
//   }
//   jQ('.' + this.class.searchResultNumber).html(content);
// };

BCSfFilter.prototype.buildSuggestionProductList = function(a, b, c, d, e) {
  var f = "";
  f += this.buildSuggestionHeader("Top Suggestions", "product");
  var g = this.buildSuggestionDidYouMean(a, e, c);
  if ("" != g && (f += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + g + "</li>"),
  Object.keys(b).length > 0)
    for (var h = 0, i = 0; i < b.length && h < d.number; i++) {
      var j = b[i]
        , k = this.customizeSuggetionProductTitle(j.title, a, b);
      k = this.highlightSuggestionResult(k, a);
      var l = this.buildProductItemUrl(j, !1)
        , m = j.images_info.length > 0 ? this.optimizeImage(j.images_info[0].src, "200x") : bcSfFilterConfig.general.no_image_url
        , n = null !== j.skus && j.skus.length > 0 ? j.skus[0] : ""
        , o = this.class.searchSuggestion
        , p = this.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";
      if(j.product_type == 'Sample' || j.product_type == 'Free Gift') {
        h++;
        continue;
      }
      f += '<li class="' + this.class.searchSuggestionItem + " " + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(d.label) + ": " + this.escape(j.title) + '">',
      f += '<a href="' + l + '" ' + p + ">",
      this.getSettingValue("search.showSuggestionProductImage") && (f += '<div class="' + o + '-left"><img src="' + m + '" /></div>'),
      f += '<div class="' + o + '-right">',
      f += '<div class="' + o + '-product-title">' + k + "</div>",
      this.getSettingValue("search.showSuggestionProductSku") && (f += '<div class="' + o + '-product-sku">SKU: ' + n + "</div>"),
      this.getSettingValue("search.showSuggestionProductVendor") && (f += '<div class="' + o + '-product-vendor">' + j.vendor + "</div>"),
      f += this.buildSuggestionProductPrice(j),
      f += "</div>",
      f += "</a>",
      f += "</li>",
      h++
    }
  return f
}

BCSfFilter.prototype.buildSuggestionCollection = function(a, b, c, d, e) {
  var f = "";
  if (Object.keys(b).length > 0) {
      var f = bcsffilter.buildSuggestionHeader(d.label, "collection");
      for (var g in b)
          if (g < d.number) {
              if(b[g].handle == 'free-samples') {
                continue;
              }
              var h = bcsffilter.highlightSuggestionResult(b[g].title, a);
              f += '<li class="' + bcsffilter.class.searchSuggestionItem + '" aria-label="' + this.escape(d.label) + ": " + this.escape(b[g].title) + '">',
              f += '<a href="/collections/' + b[g].handle + '">' + h + "</a>",
              f += "</li>"
          }
  }
  return f
}

BCSfFilter.prototype.showSuggestionLoading = function(a, b) {

  if (b !== '#bc-sf-search-box-2') {
    $('[data-site-overlay]').addClass('active')
  }

  var c = this;
  if (this.getSettingValue("search.showSuggestionLoading")) {
    jQ(a).children().hide();
    var d = this.class.searchSuggestionLoading;
    if (0 == jQ("." + d).length) {
      this.buildSuggestionWrapper(a, b);
      var e = d + "-img"
        , f = '<li class="' + d + '"><ul><li><div class="' + e + '"></div></li><li><div class="' + e + '"></div></li><li><div class="' + e + '"></div></li></ul></li>';
      if (jQ(a).prepend(f),
      jQ(a).show(),
      !c.isSuggestionStyle2()) {
        var g = this.getSuggestionWidth(b);
        jQ(a).outerWidth(g);
        var h = getSuggestionPosition(b)
          , i = this.checkIsFullWidthSuggestionMobile(b) ? "top" : "top+12";
        "left" == h ? jQ(a).position({
          my: "left " + i,
          at: "left bottom",
          of: jQ(b)[0]
        }) : jQ(a).position({
          my: "right " + i,
          at: "right bottom",
          of: jQ(b)[0]
        })
      }
    }
    jQ("." + d).show()
  }
}


/* Start Search Redirect */
function submitSearchFormMobile(t,e){e.preventDefault();var o=bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm);o?window.location.href=o:jQ(t).closest("form").submit()}function beforeSubmitSearchForm(t,e){var o=jQ(t).val(),i=bcsffilter.getSearchRedirectUrl(o);i&&(e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),window.location.href=i)}BCSfFilter.prototype.setSuggestionPosition=function(t){var e=this;if("function"==typeof getSuggestionPosition&&"function"==typeof this.checkIsFullWidthSuggestionMobile){var o=getSuggestionPosition(t),i=this.checkIsFullWidthSuggestionMobile(t)?"top":"top+12";"function"!=typeof e.isSuggestionStyle2||e.isSuggestionStyle2(),"left"==o?jQ(t).autocomplete("option","position",{my:"left "+i,at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right "+i,at:"right bottom",collision:"none"})}else"left"==this.getSettingValue("search.suggestionPosition")?jQ(t).autocomplete("option","position",{my:"left top+12",at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right top+12",at:"right bottom",collision:"none"});if(jQ(t).length>0&&jQ(t).on("keydown",function(o){13==o.keyCode&&e.enterSearchBoxEvent(t,o)}),jQ(t).closest("form").length>0){var n=jQ(t).closest("form").find('[type="submit"]');n&&n.length>0&&n.each(function(e,o){o.setAttribute("onclick","beforeSubmitSearchForm('"+t+"', event)")})}},BCSfFilter.prototype.enterSearchBoxEvent=function(t,e){var o=jQ(t).val(),i=this.getSearchRedirectUrl(o);i&&(e.preventDefault(),window.location.href=i)},BCSfFilter.prototype.getSearchRedirectUrl=function(t){if(this.suggestionCache&&this.suggestionCache.hasOwnProperty(t))for(var e=this.suggestionCache[t],o=0;o<e.length;o++)if("redirect"==e[o].key&&e[o].values){var i=e[o].values;return i=(i=i.replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,"")}return""};
/* End Search Redirect */

BCSfFilter.prototype.getSearchRedirectUrl = function (searchTerm) {
    var redirectUrl = '';
    if (searchTerm) {
        if (typeof searchTerm !== 'string'){
            searchTerm = searchTerm.toString();
        }
        searchTerm = searchTerm.trim().toLowerCase();
        if (this.suggestionCache.hasOwnProperty(searchTerm)) {
            var cachedResult = this.suggestionCache[searchTerm];
            for (var i = 0; i < cachedResult.length; i++) {
                if (cachedResult[i].key == 'redirect' && cachedResult[i].values) {
                    // Check is there is a redirect
                    redirectUrl = cachedResult[i].values;
                    redirectUrl = redirectUrl.replace('https://' + bcSfFilterMainConfig.shop.domain, '');
                    redirectUrl = redirectUrl.replace('http://' + bcSfFilterMainConfig.shop.domain, '');    
                }
            }
        }
    }
    return redirectUrl;
};